export const apiUrl = "https://www.alphavantage.co"


